import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VIDEOS = [
  {
    id: "work-video-1",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_kede-services/artifacts/b17904aca6d337de_WhatsApp%20Video%202026-10-23%20at%2015.11.31.mp4",
    caption: "Sofa deep clean",
    rotate: "lg:-rotate-2",
  },
  {
    id: "work-video-2",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_kede-services/artifacts/6b0e6e44825c6438_WhatsApp%20Video%202026-10-08%20at%2015.57.42.mp4",
    caption: "Floor & upholstery care",
    rotate: "lg:rotate-2",
  },
];

export default function WorkVideos() {
  return (
    <section id="at-work" className="relative overflow-hidden bg-[#F3EDE2] py-24 sm:py-32">
      <div className="pointer-events-none absolute -left-24 bottom-0 h-[420px] w-[420px] rounded-full bg-[#E2EFEA] blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mx-auto mb-14 max-w-2xl text-center"
        >
          <p className="font-jbm text-xs font-semibold uppercase tracking-[0.3em] text-[#C85A32]">On the job</p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-[#1C3B2B] sm:text-4xl lg:text-5xl">
            Watch us at work
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#525B53] sm:text-lg">
            Real clips from real KeDe-Ceaning jobs around Shanzu — no staging, just the crew doing what we do.
          </p>
        </motion.div>

        <div className="flex flex-col items-center justify-center gap-10 lg:flex-row lg:gap-14">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className={`w-full max-w-[300px] transition-transform duration-500 hover:rotate-0 hover:scale-[1.02] ${v.rotate}`}
            >
              <div className="overflow-hidden rounded-[2rem] border-[6px] border-white shadow-[0_35px_70px_-30px_rgba(28,59,43,0.5)]">
                <video
                  data-testid={v.id}
                  src={v.src}
                  muted
                  loop
                  autoPlay
                  playsInline
                  controls
                  preload="metadata"
                  className="aspect-[9/16] w-full bg-[#1A1C18] object-cover"
                />
              </div>
              <figcaption className="mt-4 flex items-center justify-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#1C3B2B] text-[#FBF9F5]">
                  <Play size={12} fill="currentColor" />
                </span>
                <span className="font-display text-sm font-bold text-[#1C3B2B]">{v.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
